import { render, staticRenderFns } from "./BasePaginationContainer.vue?vue&type=template&id=1af018b0&scoped=true"
import script from "./BasePaginationContainer.vue?vue&type=script&lang=js"
export * from "./BasePaginationContainer.vue?vue&type=script&lang=js"
import style0 from "./BasePaginationContainer.vue?vue&type=style&index=0&id=1af018b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af018b0",
  null
  
)

export default component.exports